import styled from "@emotion/styled";

const StyledOrderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .page-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    border: 1px dashed var(--cms-border);
    border-radius: 14px;
    font-size: 14px;
    font-weight: 600;
    color: var(--cms-text-secondary);
    background: var(--cms-surface-muted);
  }
`;

const StyledOrderSearch = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledOrderSearchBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  width: 100%;
  padding: 14px;
  border-radius: 14px;
  background: var(--cms-surface-muted);
  border: 1px solid var(--cms-border);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);

  .MuiTextField-root,
  .MuiFormControl-root {
    min-width: 170px;
  }

  .time-input {
    width: 162px;
  }

  .search-btn,
  .clear-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
  }

  .search-btn {
    box-shadow: 0 12px 24px rgba(29, 78, 216, 0.22);
  }
`;

const StyledOrderTable = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;

  .MuiTableContainer-root {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }

  .search-record-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 13px;
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
  }

  .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
  }

  .empty-row {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }

  .action-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-width: 88px;
  }

  .pagination-section {
    display: flex;
    justify-content: flex-end;
  }
`;

const StyledOrderDetail = styled.div`
  display: flex;
  margin-top: 14px;

  .detail-card {
    width: min(760px, 100%);
    border-radius: 16px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-secondary);
    box-shadow: 0 14px 28px rgba(15, 23, 42, 0.08);
  }

  .detail-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
  }

  .detail-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px;
    margin-top: 12px;
  }

  .detail-item {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    padding: 10px 11px;
    background: var(--cms-surface-muted);
  }

  .detail-label {
    margin: 0 0 6px;
    font-size: 12px;
    color: var(--cms-text-secondary);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .detail-value {
    font-size: 14px;
    color: var(--cms-text-primary);
    line-height: 1.45;
    word-break: break-word;
  }

  .detail-close-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
  }
`;

export {
  StyledOrderSection,
  StyledOrderSearch,
  StyledOrderSearchBar,
  StyledOrderTable,
  StyledOrderDetail,
};
